module.exports = __webpack_public_path__ + "img/gpy5.5c455dce.png";